import { mapValuesWithInvoke } from '@/utils'

import jobOffer from './data/job-offer'

export default mapValuesWithInvoke({ jobOffer })
